import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../../components";
import { IoIosArrowRoundForward } from "react-icons/io";
import styles from "./PayNow.module.scss";

export default function PayNow(props) {
  const navigate = useNavigate();
  
  const handlePaymentOrder = () => {
    navigate("/re-payment");
  };
  const { loanSummary } = props;

  return (
    <div className={styles.totalAmount}>
      <div>
        <p>Total</p>
        <h5>₹{loanSummary.amountToBeRepayed}</h5>
        <span className={styles.taxText}>Inclusive of all taxes</span>
      </div>
      <div>
        <CustomButton floating={false} text="Pay Now" endIcon={<IoIosArrowRoundForward size={30} />} onClick={handlePaymentOrder} />
      </div>
    </div>
  );
}
